module.exports = __webpack_public_path__ + "static/media/klickly-spinner.fe2c9225.svg";